import OrderCollectBlock from './OrderCollectBlock';

export default OrderCollectBlock;
